
import { PopupModal } from "../../../../components/PopupModal";
import { ReactComponent as CloseIcon } from "../../../../assets/icons/x.svg";
import { useMemo, useState } from "react";
import { Button } from "../../../../components/Button";
import { api } from "../../../../services/api";
import { ShowToast } from "../../../../services/toast";
import { PracticePermission, UserWithPracticePermissions } from "../PracticePermissions.types";
import { PracticePermissionsGrid } from './PracticePermissionsGrid';

export function MemberPermissionModal({ member, onClose }: { member: UserWithPracticePermissions, onClose: () => void }) {
  const [loading, setLoading] = useState<boolean>(false);
  const [permissions, setPermissions] = useState<PracticePermission[]>(member.permissions);
  const [editMode, setEditMode] = useState<boolean>(false);

  const changeMade = useMemo(() => {
    if (permissions.length !== member.permissions.length) return true;
    return permissions.some((permission) => !member.permissions.includes(permission))
  }, [permissions, member.permissions]);


  const handleSubmit = async () => {
    setLoading(true);
    try {
      await api.updatePracticePermissionsForProvider({
        secondaryBcbaUserId: member.id,
        permissions
      });
      ShowToast({
        type: "success",
        message: "Permissions updated successfully",
      });
      setEditMode(false);
      setLoading(false);
      onClose();
    } catch (error) {
      setLoading(false);
      ShowToast({
        type: "error",
        message: "Error updating permissions",
      });
      console.error(error);
    }
  };


  return (
    <PopupModal
      contentClassName="p-8 z-[2] w-[98%] self-center bg-white rounded-2xl flex-col justify-start items-center gap-6 flex w-full md:mx-auto md:w-[842px] max-w-[842px]"
      onClose={onClose}
      shouldStopPropagation={false}
    >
      <>
        <div className="w-full justify-between items-start flex">
          <div className="inline-block text-black text-2xl font-bold font-['Outfit'] leading-7">
            {member.name} Permissions
          </div>
          <div className="justify-end items-center gap-3 flex">
            <button onClick={onClose}>
              <CloseIcon className="w-6 h-6" />
            </button>
          </div>
        </div>
        <div className="w-full max-h-[calc(100vh-160px)] lg:max-h-[calc(100vh-155px)] overflow-auto" id="provider-scroll">
          <div className="flex flex-col mb-5">
            <div className={`bg-white`}>
              <div className="mt-1">
                <PracticePermissionsGrid
                  permissions={permissions}
                  setPermissions={setPermissions}
                  disabled={!editMode}
                />
              </div>
            </div>

          </div>


          <div className="w-full">
            {editMode ?
              <div className="grid grid-cols-2 gap-10 px-1">
                <Button
                  disabled={loading}
                  variant="outline"
                  className="!rounded-full w-full mt-0"
                  onClick={onClose}
                  loading={loading}
                >
                  Cancel
                </Button>
                <Button
                  disabled={loading}
                  variant={(!changeMade) ? "outline" : "primary"}
                  className="!rounded-full w-full mt-0"
                  onClick={() => (changeMade) ? handleSubmit() : setEditMode(false)}
                  loading={loading}
                >
                  {(changeMade) ? "Save" : "Stop Editing"}
                </Button>
              </div>
              :
              <div className="grid grid-cols-2 gap-10 px-1">
                <div/>
                <Button
                  disabled={loading}
                  variant="primary"
                  className="!rounded-full w-full mt-0 hover:bg-black"
                  onClick={() => setEditMode(true)}
                  loading={loading}
                >
                  Edit Permissions
                </Button>
              </div>
            }
          </div>

        </div>
      </>
    </PopupModal >);
}
